<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.USER.START_CANCEL_REGISTRATION"
    :handler="() => $refs.modal.show()"
  />
  <DialogComponent ref="modal" type="bottomsheet">
    <div>
      <div class="text-2xl ">Voulez vous vraiment annuler ?</div>
      <div class="text-lg mt-2 ">Vous allez recommencer l'inscription depuis le début</div>
      <div class="flex justify-between gap-8 mt-8">
        <button
          class="w-1/2 buttonComponent"
          v-bus:EVENTS.USER.CONFIRM_CANCEL_REGISTRATION.click
        >
          Recommencer
        </button>
        <button
          @click="() => $refs.modal.hide()"
          class="w-1/2 buttonComponent !bg-primary"
        >
          Continuer
        </button>
      </div>
    </div>
  </DialogComponent>
</template>
